import { useTranslation } from 'react-i18next'

import { Text } from '@enechain/ecloud-designsystem'

import { type CivilDate, civilDateToDate } from '~/models/civilDate'
import { formatDateDisplay } from '~/models/dateTime'

type Props = {
  from: CivilDate | undefined
  to: CivilDate | undefined
  /** 表示中の清算書の件数 (0 件を含む)。 */
  count: number
}

const formatSide = (d: CivilDate | undefined): string =>
  d === undefined ? '' : formatDateDisplay(civilDateToDate(d))

/**
 * 一覧の上に出す、 指定中の期間 (未指定なら「すべて」) と表示中の清算書の件数 (AC-JST-002)。
 *
 * 置き場所と見た目は 8080 `bidding/settlement.html` の `.stl-summary` (ツールバーの下・
 * sm・`Text.midEmphasis`、 「清算日: すべて ・ 3件」)。 0 件の空状態でも出し、 会員 ID 未設定・
 * 取得失敗の時は出さない (呼び出し側が判定する)。 見出し・期間・件数は要素を分ける
 * (8080 と同じ。 件数だけ・「すべて」 だけを引けるようにするため)。
 */
export const PeriodSummary = ({
  from,
  to,
  count,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const isPeriodSet = from !== undefined || to !== undefined

  return (
    <Text
      textStyle="captionNormal"
      color="Text.midEmphasis"
      fontVariantNumeric="tabular-nums"
    >
      <span>{t('page:jepxSettlement.filter.period')}</span>
      {': '}
      <span>
        {isPeriodSet
          ? t('page:jepxSettlement.filter.periodRange', {
              from: formatSide(from),
              to: formatSide(to),
            })
          : t('page:jepxSettlement.filter.all')}
      </span>
      {t('page:jepxSettlement.filter.summarySeparator')}
      <span>{t('page:jepxSettlement.filter.count', { count })}</span>
    </Text>
  )
}
